export const PERIOD = ['Last 30 days', 'Last 3 month', 'Last year'];

export const TOTAL_PHYSICIAN_ENGAGEMENT_CHART_OPTIONS = {
    chart: {
        id: 'basic-bar',
        toolbar: {
            show: false,
        },
    },
    noData: {
        text: 'No data to display',
        align: 'center',
        verticalAlign: 'middle',
        offsetX: 0,
        offsetY: 0,
        style: {
          color: '#000000',
          fontSize: '14px',
        }
    },
    colors: ['#4EAAF8'],
    xaxis: {
        type: 'category',
        categories: ['', '', '', '', '', ''],
        show: false,
        axisTicks: {
            show: false,
        },
        axisBorder: {
            show: false,
        },
        labels: {
            show: false,
          },
    },
    legend: { show: false },
    yaxis: {
        show: false,
        axisTicks: {
            show: false,
        },
        axisBorder: {
            show: false,
        },
        labels: {
            show: false,
            formatter: function(val) {
              return val.toFixed(0)
            }
          },
    },
    grid: {
        show: false,
        padding: {
            top:0,
            right:0,
            bottom:0,
            left:0,
        },
    },
    
    plotOptions: {
        bar: {
            columnWidth: '80%',
        },
    },
    stroke: {
        show: true,
        width: 2,
        colors: ['transparent'],
    },
    dataLabels: {
        enabled: false,
    },
    tooltip: {
        
            show: true,
            

    }
    
};
export const TOTAL_PHYSICIAN_ENGAGEMENT_CHART_SERIES = [
    {
        name: '',
        data: [
            30, 40, 35, 50, 49, 60,
            30, 40, 35, 50, 49, 60,
            30, 40, 35, 50, 49, 60,
            30, 40, 35, 50, 49, 60,
            30, 40, 35, 50, 49, 60,
        ],
    },
]

export const FIELD_PHYSICIAN_ENGAGEMENT_CHART_OPTIONS = {
    chart: {
        id: 'basic-bar',
        toolbar: {
            show: false,
        },
    },
    noData: {
        text: 'No data to display',
        align: 'center',
        verticalAlign: 'middle',
        offsetX: 0,
        offsetY: 0,
        style: {
          color: '#000000',
          fontSize: '14px',
        }
    },
    colors: ['#FEB273'],
    xaxis: {
        type: 'category',
        categories: ['', '', '', '', '', ''],
        show: false,
        axisTicks: {
            show: false,
        },
        axisBorder: {
            show: false,
        },
        labels: {
            show: false,
          },
    },
    legend: { show: false },
    yaxis: {
        show: false,
        axisTicks: {
            show: false,
        },
        axisBorder: {
            show: false,
        },
          labels: {
            show: false,
            formatter: function(val) {
              return val.toFixed(0)
            }
          },
    },
    grid: {
        show: false,
        padding: {
            top:0,
            right:0,
            bottom:0,
            left:0,
        },
    },
    plotOptions: {
        bar: {
            columnWidth: '80%',
        },
    },
    stroke: {
        show: true,
        width: 2,
        colors: ['transparent'],
    },
    dataLabels: {
        enabled: false,
    },
    tooltip: {
       show: true,
    }
};

export const FIELD_PHYSICIAN_ENGAGEMENT_CHART_SERIES = [
    {
        name: '',
        data: [
            30, 40, 35, 50, 49, 60, 30, 40, 35, 50, 49, 60
        ],
    },
];


export const DIGITAL_PHYSICIAN_ENGAGEMENT_CHART_OPTIONS = {
    chart: {
        id: 'area-chart',
        toolbar: {
            show: false,
        },
        height:"600px",
    },
    noData: {
        text: 'No data to display',
        align: 'center',
        verticalAlign: 'middle',
        offsetX: 0,
        offsetY: 0,
        style: {
          color: '#000000',
          fontSize: '14px',
        }
    },
    colors: ['#FB6514'],
    xaxis: {
        type: 'category',
        show: false,
        axisTicks: {
            show: false,
        },
        axisBorder: {
            show: false,
        },
        labels: {
            show: false,
          },
          tooltip: {
            enabled: false,
          },
    },
    legend: { show: false },
    yaxis: {
        show: false,
        axisTicks: {
            show: false,
        },
        axisBorder: {
            show: false,
        },
        labels: {
            show: false,
            formatter: function(val) {
              return val.toFixed(0)
            }
          },
    },
    grid: {
        show: false,
        padding: {
            top:0,
            right:0,
            bottom:0,
            left:0,
        },
    },
    tooltip: {
        enabled: true,
      },
    plotOptions: {
        bar: {
            columnWidth: '80%',
        },
    },
    stroke: {
        show: true,
        width: 2,
        colors: ['transparent'],
    },
    dataLabels: {
        enabled: false,
    },
};
export const DIGITAL_PHYSICIAN_ENGAGEMENT_CHART_SERIES = [
    {
        name: '',
        data: [30, 40, 25, 50, 49, 60],
    },
];